import { render } from "./PlatformYearReport.vue?vue&type=template&id=d2b0496a&scoped=true"
import script from "./PlatformYearReport.vue?vue&type=script&lang=js"
export * from "./PlatformYearReport.vue?vue&type=script&lang=js"

import "./PlatformYearReport.vue?vue&type=style&index=0&id=d2b0496a&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b0496a"]])

export default __exports__